<div class="public-chat-box">
  <form
    class="public-chat-box__form"
    [formGroup]="publicChatForm"
    (submit)="submitContactForm()">
    <!-- name input -->
    <pwj-input
      icon="user-1"
      iconPosition="left"
      placeholder="global.enter_your_full_Name"
      label="global.full_Name"
      formControlName="name"
      [messages]="{ required: 'requires.fullName' }"></pwj-input>

    <!-- phone number input -->
    <pwj-phone-number
      icon="phone"
      iconPosition="left"
      placeholder="global.enter_your_phone"
      label="global.phone_number"
      formControlName="mobile"
      [messages]="{ required: 'requires.phoneNumber' }"></pwj-phone-number>

    <!-- submit btn -->
    <div class="form-btn-container">
      <pwj-button
        variant="primary"
        size="medium"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        type="submit"
        >{{ 'global.startChat' | translate }}</pwj-button
      >
    </div>
  </form>

  @if (isChatLoading) {
    <div class="public-chat-box__loading-page">
      <img
        ngSrc="assets/icons/messenger-loading-icon.svg"
        alt="loading"
        width="40"
        height="40" />
    </div>
  }
</div>
